import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { HXMobileButton } from "./HXButton";
export const LongPressButton = (props) => {
    const [longPressMode, setLongPressMode] = React.useState(false);
    const touchTimer = React.useRef(null);
    const [touchChangedMode, setTouchChangedMode] = React.useState(false);
    const effectiveLabel = props.flip ? props.longPressLabel : props.label;
    const effectiveLongPressLabel = props.flip ? props.label : props.longPressLabel;
    return (_jsx(HXMobileButton, { onPointerDown: onPointerDown, onPointerUp: onPointerUp, onPointerLeave: onPointerUp, ...props, label: effectiveLongPressLabel, longPressLabel: effectiveLabel, onClick: onClick, children: longPressMode ? effectiveLongPressLabel : effectiveLabel }));
    async function onClick(event) {
        var _a;
        event.preventDefault();
        if (touchChangedMode)
            return;
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, props.flip ? !longPressMode : longPressMode, event);
    }
    async function onPointerDown() {
        touchTimer.current = window.setTimeout(() => {
            setLongPressMode(!longPressMode);
            setTouchChangedMode(true);
        }, 5000);
    }
    function onPointerUp() {
        if (touchTimer.current !== null) {
            window.clearTimeout(touchTimer.current);
            touchTimer.current = null;
        }
        if (touchChangedMode) {
            window.setTimeout(() => {
                setTouchChangedMode(false);
            }, 50);
        }
    }
};
